export class CreateTariffModel {
  public tipoId: number = 0
  public origemId: number = 0
  public destinoId: number = 0
  public tipoServicoId: number = 0
  public servicoId: number = 0
  public tipoVeiculoId: number = 0
  public tipoMotoristaId: number = 0
  public clienteId: number = 0
  public fornecedorId: number = 0
  public custo: number = 0.0
  public custoHoraExtra: number = 0.0
  public custoKmExtra: number = 0.0
  public ativo: string = 'N'
  public dataValidade: string = ''
}

export class EditTariffModel {
  public id: number = 0
  public tipoId: number = 0
  public origemId: number = 0
  public destinoId: number = 0
  public tipoServicoId: number = 0
  public servicoId: number = 0
  public tipoVeiculoId: number = 0
  public tipoMotoristaId: number = 0
  public clienteId: number = 0
  public fornecedorId: number = 0
  public custo: number = 0
  public custoHoraExtra: number = 0
  public custoKmExtra: number = 0
  public ativo: number = 0
  public dataValidade: number = 0
}

export class DeleteTariffModel {
  public id: number = 0
  public descricao: string = ''
}

export class SearchTariffModel {
  public descricao: string = ''
}

export class CreateTariffResponse {
  public response: any
}
export class EditTariffResponse {
  public response: any
}
export class DeleteTariffResponse {
  public response: any
}
export class PagedTariffResponse {
  public response: any
}

export class ImportTariffModel {
  public TipoTarifario: number = 0
  public ClienteId: number = 0
  public ExcelFile: File | null = null

  public toFormData(): FormData {
    const formData = new FormData()

    formData.append('TipoTarifario', this.TipoTarifario.toString())
    formData.append('ClienteId', this.ClienteId.toString())

    if (this.ExcelFile) {
      formData.append('ExcelFile', this.ExcelFile)
    }

    return formData
  }
}

export class ImportTariffNewModel {
  public TipoTarifario: number = 0
  public ClienteId: number = 0
  public FornecedorId: number = 0
  public ExcelFile: File | null = null

  public toFormData(): FormData {
    const formData = new FormData()

    formData.append('TipoTarifario', this.TipoTarifario.toString())
    formData.append('ClienteId', this.ClienteId.toString())
    formData.append('FornecedorId', this.FornecedorId.toString())

    if (this.ExcelFile) {
      formData.append('ExcelFile', this.ExcelFile)
    }

    return formData
  }
}
